<template>
  <div class="login_box">
    <div class="content">
      <div class="login_content" v-if="!showResetPassword">
        <h1 class="title">欢迎登录</h1>
        <div class="form_group">
          <el-input
            v-model="loginForm.username"
            placeholder="用户名/手机号"
            class="input_field"
            :prefix-icon="User"
            clearable
          />
        </div>
        <div class="form_group">
          <el-input
            v-model="loginForm.password"
            placeholder="密码"
            class="input_field"
            :prefix-icon="Lock"
            :type="showPassword ? 'text' : 'password'"
            clearable
            show-password
            @keyup.enter="handleLogin"
          >
            <template #suffix>
              <!-- <el-icon
                class="password_icon"
                @click="showPassword = !showPassword"
              >
                <View v-if="showPassword" />
                <Hide v-else />
              </el-icon> -->
            </template>
          </el-input>
        </div>
        <div class="form_group">
          <el-button
            type="primary"
            class="login_btn"
            @click="handleLogin"
            :loading="loading"
          >
            登 录
          </el-button>
        </div>
        <!-- <div class="links">
          <a href="#" class="link" @click.prevent="showResetPassword = true">
            忘记密码
          </a>
          <a href="#" class="link">注册账号</a>
        </div> -->
      </div>

      <div class="login_content" v-else>
        <h1 class="title">重置密码</h1>
        <div class="form_group">
          <el-input
            v-model="resetForm.username"
            placeholder="用户名/手机号"
            class="input_field"
            :prefix-icon="User"
            clearable
          />
        </div>
        <div class="form_group">
          <el-input
            v-model="resetForm.newPassword"
            placeholder="新密码"
            class="input_field"
            :prefix-icon="Lock"
            :type="showNewPassword ? 'text' : 'password'"
            clearable
            show-password
          >
            <template #suffix>
              <!-- <el-icon
                class="password_icon"
                @click="showNewPassword = !showNewPassword"
              >
                <View v-if="showNewPassword" />
                <Hide v-else />
              </el-icon> -->
            </template>
          </el-input>
        </div>
        <div class="form_group">
          <el-input
            v-model="resetForm.confirmPassword"
            placeholder="确认新密码"
            class="input_field"
            :prefix-icon="Lock"
            :type="showConfirmPassword ? 'text' : 'password'"
            clearable
            show-password
          >
            <template #suffix>
              <!-- <el-icon
                class="password_icon"
                @click="showConfirmPassword = !showConfirmPassword"
              >
                <View v-if="showConfirmPassword" />
                <Hide v-else />
              </el-icon> -->
            </template>
          </el-input>
        </div>
        <div class="form_group">
          <el-button
            type="primary"
            class="login_btn"
            @click="handleResetPassword"
            :loading="loading"
          >
            确认修改
          </el-button>
        </div>
        <div class="links">
          <a href="#" class="link" @click.prevent="showResetPassword = false">
            返回登录
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from "vue";
import { User, Lock, View, Hide } from "@element-plus/icons-vue";
import { ElMessage } from "element-plus";
import { useUserStore } from "@/views/stores/order";
import { PostLogin, PostUserInfo, PostUserCarList } from "@/api/index.js";
import { useRouter, useRoute } from "vue-router";
import { Cookie } from "@/utils/Cookie";
const router = useRouter();
const route = useRoute();
const userStore = useUserStore();
const loading = ref(false);
const cardList = ref([]);
// 登录表单数据
const loginForm = reactive({
  username: "",
  password: "",
});

// 重置密码表单数据
const resetForm = reactive({
  username: "",
  newPassword: "",
  confirmPassword: "",
});

const showPassword = ref(false);
const showNewPassword = ref(false);
const showConfirmPassword = ref(false);
const showResetPassword = ref(false);

// onMounted(()=>{
//   localStorage.clear();
// })
onMounted(() => {
  // cardList.value = JSON.parse(
  //   localStorage.getItem("addCardListParams") || "[]"
  // );
});
// 拆分URL为 path 和 query 对象（处理from参数）
const parseFromUrl = (fromUrl) => {
  if (!fromUrl) return { path: "/", query: {} }; // 默认跳转首页

  // 分割 "路径" 和 "查询参数"（以?为界）
  const [path, queryStr] = fromUrl.split("?");
  const query = {};

  // 如果有查询参数（如?id=xxx），解析成对象
  if (queryStr) {
    queryStr.split("&").forEach((item) => {
      const [key, value] = item.split("=");
      if (key) query[key] = decodeURIComponent(value); // 解码特殊字符
    });
  }

  return { path: path || "/", query };
};
const handleLogin = async () => {
   cardList.value = JSON.parse(
    localStorage.getItem("addCardListParams") || "[]"
  );
  const from = router.currentRoute.value.query.from;
  const card = router.currentRoute.value.query;
  if (!loginForm.username.trim()) {
    ElMessage.warning("请输入用户名");
    return;
  }

  if (!loginForm.password.trim()) {
    ElMessage.warning("请输入密码");
    return;
  }

  try {
    loading.value = true;
    const params = {
      username: loginForm.username,
      password: loginForm.password,
    };

    const res = await PostLogin(params);

    if (res?.status === 200) {
      const token = res?.info?.token;
      if (res?.info?.result == "IPTIMEOUT") {
        ElMessage.warning("当前用户已过期，请联系销售人员处理！");
        return;
      }
      if (res?.info?.result != "SUCCESSED") {
        ElMessage.warning(res.message);
        return;
      }
      if (!token) {
        console.log("登录失败，请重试");
      }      
      Cookie.set("token", JSON.stringify(token));
      const resinfo = await PostUserInfo();

      if (resinfo?.info) {
        userStore.setUserInfo(token, resinfo.info);
        const selectedData = getSelectedCardsData();
        if (cardList.value) {
          const response = await PostUserCarList({ cart: selectedData });

          if (response?.info || response?.status === 200) {
            ElMessage.success("登录成功");
            const { path, query } = parseFromUrl(from); 

            if (cardList.value) {
              const response = await PostUserCarList({ cart: selectedData });
              if (response?.info || response?.status === 200) {
                // ElMessage.success("登录成功");
                router.push({ path, query });
                localStorage.removeItem("addCardListParams");
              }
            } else {
              ElMessage.success("登录成功");
              router.push({ path, query });
            }
            localStorage.removeItem("addCardListParams");
          }
        } else {
          ElMessage.success("登录成功");
          const { path, query } = parseFromUrl(from);

          if (cardList.value) {
            const response = await PostUserCarList({ cart: selectedData });
            if (response?.info || response?.status === 200) {
              ElMessage.success("登录成功");
              router.push({ path, query });
              localStorage.removeItem("addCardListParams");
            }
          } else {
            ElMessage.success("登录成功");
            router.push({ path, query });
          }
        }
      } else {
        ElMessage.success(res?.message || "登录成功");
      }
    } else {
      ElMessage.error(res?.message || "登录失败");
    }
  } catch (error) {
    console.error("登录错误:", error);
    ElMessage.error(error.message || "登录过程中发生错误");
  } finally {
    loading.value = false;
  }
};

// 获取已选中的卡片数据
const getSelectedCardsData = () => {
  return cardList.value.map((item) => ({
    knowledgeId: item.id,
    knwoledgeTitle: item.title,
    publishUnit: item.publishUnit,
    knowledgeVersion: "netVersion",
    netVersion: item.netVersion,
    mirrorVersion: item.mirrorVersion,
    netPrice: item.netPrice,
    mirrorPrice: item.mirrorPrice,
    netPrice20: item.netPrice20,
    netPrice50: item.netPrice50,
    netPrice100: item.netPrice100,
    netPrice200: item.netPrice200,
  }));
};

const handleResetPassword = async () => {
  if (!resetForm.username.trim()) {
    ElMessage.warning("请输入用户名");
    return;
  }

  if (!resetForm.newPassword.trim() || !resetForm.confirmPassword.trim()) {
    ElMessage.warning("请输入新密码和确认密码");
    return;
  }

  if (resetForm.newPassword !== resetForm.confirmPassword) {
    ElMessage.error("两次输入的密码不一致");
    return;
  }

  try {
    loading.value = true;
    // 这里添加密码重置逻辑
    console.log("重置密码信息:", {
      username: resetForm.username,
      newPassword: resetForm.newPassword,
    });

    ElMessage.success("密码修改成功");
    showResetPassword.value = false;
    resetForm.username = "";
    resetForm.newPassword = "";
    resetForm.confirmPassword = "";
  } catch (error) {
    console.error("重置密码错误:", error);
    ElMessage.error(error.message || "密码修改过程中发生错误");
  } finally {
    loading.value = false;
  }
};
</script>

<style scoped>
.login_box {
  width: 100%;
  height: 100vh;
  background-image: url(@/assets/image/LoginImage6.jpg);
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
}

.content {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  /* backdrop-filter: blur(2px); */
}

.login_content {
  width: 400px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 10px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
  text-align: center;
  animation: fadeIn 0.3s ease;
}

.title {
  margin-bottom: 30px;
  color: #333;
  font-size: 24px;
}

.form_group {
  margin-bottom: 20px;
}

:deep(.input_field) {
  width: 100%;
  font-size: 16px;
}

.login_btn {
  width: 100%;
  padding: 12px;
  font-size: 16px;
}

.links {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.link {
  color: #999;
  text-decoration: none;
  font-size: 14px;
  transition: color 0.3s;
  cursor: pointer;
}

.link:hover {
  color: #409eff;
}

.password_icon {
  cursor: pointer;
  color: #c0c4cc;
  transition: color 0.3s;
}

.password_icon:hover {
  color: #409eff;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
